"use strict";
var discoveryTS = require('./Server/Server');
module.exports = discoveryTS.default;
//# sourceMappingURL=index.js.map